// extracted by mini-css-extract-plugin
var _1 = "badge__jjX3M";
var _2 = "dot__gbNkF";
var _3 = "has-hint__Xv1tp";
var _4 = "hint__ZSLOU";
var _5 = "state__H8Ltw";
var _6 = "state--not_possible__PrIlO";
var _7 = "state--not_suitable_for_mothers__Gcuf7";
var _8 = "state--possible_with_measures__fOnnA";
export { _1 as "badge", _2 as "dot", _3 as "has-hint", _4 as "hint", _5 as "state", _6 as "state--not_possible", _7 as "state--not_suitable_for_mothers", _8 as "state--possible_with_measures" }
